import pagination_block from './pagination-block'
import contact_us_dialog from './contact-us-dialog'

export default {
  pagination_block,
  contact_us_dialog,
}
